export default __webpack_public_path__ + "static/media/thumbnail.fde0847f.png";